export default __webpack_public_path__ + "static/media/sofia_l.29c40a88.jpg";